// Réduit une image côté client avant envoi — accepte n'importe quel type/taille de photo en
// entrée (le <input type="file"> ne filtre déjà que sur "image/*", jamais sur un format précis)
// et la ré-encode systématiquement en WebP à une résolution plafonnée, pour ne jamais envoyer
// une photo de plusieurs Mo telle quelle. Si le navigateur ne sait pas décoder le fichier
// d'origine (HEIC sur Chrome/Firefox, format exotique...), on retombe sur le fichier original
// plutôt que de bloquer l'envoi — mieux vaut un envoi non compressé qu'un envoi refusé.
export function compressImage(file: File, maxDim = 1600, quality = 0.8): Promise<File> {
  return new Promise((resolve) => {
    if (!file.type.startsWith("image/")) { resolve(file); return; }
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    const cleanup = () => URL.revokeObjectURL(objectUrl);
    img.onerror = () => { cleanup(); resolve(file); };
    img.onload = () => {
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        const scale = maxDim / Math.max(width, height);
        width = Math.round(width * scale);
        height = Math.round(height * scale);
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) { cleanup(); resolve(file); return; }
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(blob => {
        cleanup();
        if (!blob) { resolve(file); return; }
        resolve(new File([blob], file.name.replace(/\.\w+$/, ".webp"), { type: "image/webp" }));
      }, "image/webp", quality);
    };
    img.src = objectUrl;
  });
}
